declare const liff: {
  init: (opts: { liffId: string }) => Promise<void>;
  isLoggedIn: () => boolean;
  isInClient: () => boolean;
  login: () => void;
  getProfile: () => Promise<{ userId: string; displayName: string }>;
  getIDToken: () => string | null;
  openWindow: (opts: { url: string; external: boolean }) => void;
};

const STATUS_LIFF_ID = import.meta.env.VITE_LIFF_ID as string | undefined;

export interface LineAuth {
  lineUserId: string;
  idToken: string | null;
}

export async function initLiffAuth(liffId?: string): Promise<LineAuth> {
  const dev = devLineUserId();
  if (dev) {
    return { lineUserId: dev, idToken: null };
  }

  const id = liffId ?? STATUS_LIFF_ID;
  if (!id) {
    throw new Error("ตั้งค่า VITE_LIFF_ID ใน .env");
  }
  await liff.init({ liffId: id });
  if (!liff.isLoggedIn()) {
    liff.login();
    throw new Error("redirecting");
  }
  const profile = await liff.getProfile();
  const idToken = liff.getIDToken();
  if (!idToken) {
    throw new Error("ไม่ได้รับ ID token จาก LINE — เปิด scope openid ใน LIFF");
  }
  return { lineUserId: profile.userId, idToken };
}

/** @deprecated use initLiffAuth */
export async function initLiff(liffId?: string): Promise<string> {
  const auth = await initLiffAuth(liffId);
  return auth.lineUserId;
}

/** เปิด LIFF เช็คสถานะ (จากหน้าส่งผ้าซักหลังสำเร็จ) */
export function openStatusLiff(): void {
  if (!STATUS_LIFF_ID) {
    window.location.href = "/";
    return;
  }
  const url = `https://liff.line.me/${STATUS_LIFF_ID}`;
  try {
    if (typeof liff !== "undefined" && liff.isInClient()) {
      liff.openWindow({ url, external: false });
      return;
    }
  } catch {
    /* fallback */
  }
  window.location.href = "/";
}

export function openPaymentPage(orderId: string): void {
  const url = `/payment.html?orderId=${encodeURIComponent(orderId)}`;
  window.location.href = url;
}

/** เปิดนอก LINE — dev เท่านั้น */
export function devLineUserId(): string | null {
  const params = new URLSearchParams(location.search);
  return params.get("devUserId");
}
